import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Loader from "@/components/Loader";

export default function ProtectedRoute({ role }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader full />;
  if (!user) return <Navigate to="/login" replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/app" replace />;
  if (role === "user" && user.role === "admin") return <Navigate to="/admin" replace />;
  return <Outlet />;
}
